import { FaRegCopy, FaPen, FaRegEye, FaRegSave } from 'react-icons/fa';
import { GoGear } from 'react-icons/go';

export const formStepsInAndEx = [
  {
    title: 'docWizard.step1.title',
    description: 'docWizard.step1.description',
    icon: FaRegCopy,
    to: '/documents-wizard/step-1',
  },
  {
    title: 'docWizard.step2.title',
    description: 'docWizard.step2.description',
    icon: GoGear,
    to: '/documents-wizard/step-2',
  },
  {
    title: 'docWizard.step3.title',
    description: 'docWizard.step3.description',
    icon: FaPen,
    to: '/documents-wizard/step-3',
  },
  {
    title: 'docWizard.step4.title',
    description: 'docWizard.step4.description',
    icon: FaRegEye,
    to: '/documents-wizard/step-4',
  },
  {
    title: 'docWizard.step5.title',
    description: 'docWizard.step5.description',
    icon: FaRegSave,
    to: '/documents-wizard/step-5',
  },
];

export const formStepsExternal = [
  {
    title: 'docWizard.step1.externalTitle',
    description: 'docWizard.step1.externalDescription',
    icon: FaPen,
    to: '/documents-wizard/step-1',
  },
  {
    title: 'docWizard.step3.externalTitle',
    description: 'docWizard.step3.externalDescription',
    icon: FaRegCopy,
    to: '/documents-wizard/step-4',
  },
  {
    title: 'docWizard.step5.title',
    description: 'docWizard.step5.description',
    icon: FaRegSave,
    to: '/documents-wizard/step-5',
  },
];

export const docTypeOptions = [
  {
    label: 'docWizard.step1.systemDocTemplates',
    value: 'internal',
  },
  {
    label: 'docWizard.step1.externalDocs',
    value: 'external',
  },
];
